import { render, staticRenderFns } from "./Editbooking.vue?vue&type=template&id=78a68710&scoped=true&"
import script from "./Editbooking.vue?vue&type=script&lang=js&"
export * from "./Editbooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a68710",
  null
  
)

export default component.exports